import { Dispatch, useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Action } from 'redux';

import { RootState } from '../../lib/store';
import { clearSignupToken as clearSignupTokenCall } from '../../lib/store/auth';

import { useIsMobile } from '../../hooks';

const NotVerifiedNotification = (props: ReduxProps) => {
  const {
    isFetchingPWPSignupURL,
    PWPSignupURL,
    clearSignupToken,
  } = props;
  const { isMobile } = useIsMobile();

  useEffect(() => {
    if (!isFetchingPWPSignupURL && PWPSignupURL) {
      window.open(PWPSignupURL, isMobile ? '_self' : '_blank');
      clearSignupToken();// removing the signup token URL from the state to avoid the re-redirection on the next render time
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetchingPWPSignupURL, PWPSignupURL, isMobile]);

  return <></>;// No verfication steps in capital
};

const mapStateToProps = (state: RootState) => ({
  isFetchingPWPSignupURL: state.auth.isFetchingPWPSignupURL,
  PWPSignupURL: state.auth.PWPSignupURL,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  clearSignupToken: () => dispatch(clearSignupTokenCall()),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(NotVerifiedNotification);
